<script>
import { mapGetters } from 'vuex';
import Base from './base.vue';
import { ZOOM_MEETING_EDU_PLUS_MIN_LICENSE, BASE_PLAN_SUB_TYPES } from '@/common/constants';
import { getAssignedLicenseQuantity } from '@/plans/ZOOM_ONE_BUNDLE/utils'
import { getMeetingPlanByCategory } from '@/plans/ZOOM_MEETING/common/utils';

export default {
  name: 'Switch',
  extends: Base,
  computed: {
    ...mapGetters(['boughtPlans', 'migratePlanState','assignInfo']),
    isShowLeastDesc() {
      return true;
    },
    addRegionVisible() {
      return false
    },
    assignedEduLicenseQuantity() {
      const boughtMeetingPlan = getMeetingPlanByCategory(this.boughtPlans, BASE_PLAN_SUB_TYPES.EDUCATION);
      return getAssignedLicenseQuantity([boughtMeetingPlan], this.assignInfo);
    },
    minCallingPlan() {
      if(this.assignedEduLicenseQuantity > ZOOM_MEETING_EDU_PLUS_MIN_LICENSE){
        return Math.max(this.assignedEduLicenseQuantity, ZOOM_MEETING_EDU_PLUS_MIN_LICENSE); 
      }
      return ZOOM_MEETING_EDU_PLUS_MIN_LICENSE;
    },
    maxCallingPlan() {
      return 9999;
    },
    planDetailLabel() {
      return this.$t('billing.zone.explore_other_plans_edit');
    }
  },
}
</script>
